import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { type FC } from 'react'
import cn from 'classnames'
import { twMerge } from 'tailwind-merge'
import { useTranslation } from '@egw/i18n'
import styles from './loader.module.css'

export const BankNameVerified: FC<{
  bankName: string | undefined
  isFetching: boolean
}> = ({ bankName, isFetching }) => {
  // -- Hooks ---------------------------------------------------------------
  const { t } = useTranslation('features-transfer')

  // -- Layout ----------------------------------------------------------------
  return (
    <div className="flex flex-row mt-1">
      <div className="flex flex-row gap-2.5 items-center">
        {isFetching ? (
          <>
            <div
              className={cn(
                twMerge(
                  'box-border rounded-[50%] border-4 border-zinc-300 border-b-transparent',
                  'border-[.15rem] border-green-400 border-b-transparent',
                ),
                {
                  [styles['loader-animation']]: true,
                },
              )}
              style={{
                width: '1rem',
                height: '1rem',
              }}
            />
            <p className="text-green-600 text-xs font-semibold">{t('external_accounts.searching')}</p>
          </>
        ) : null}
        {!isFetching && bankName ? (
          <>
            <CheckCircleIcon className="fill-green-400" width="1rem" height="1rem" />
            <p className="text-green-600 text-xs font-semibold fs-exclude">{bankName}</p>
          </>
        ) : null}
      </div>
    </div>
  )
}
